import { Toaster } from '@/components/ui/sonner'
import VisitTracker from '@/components/analytics/VisitTracker'
import { ScrollToTop } from '@/components/common/ScrollToTop'
import AppRoutes from './router'
import { AuthProvider } from './hooks/useAuth'
import { usePlatformSettings } from './hooks/usePlatformSettings'

export default function App() {
  usePlatformSettings()

  return (
    <AuthProvider>
      <VisitTracker />
      <ScrollToTop />
      <AppRoutes />
      <Toaster position="top-center" />
    </AuthProvider>
  )
}
